//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/LineDesigner.js";
import "../no/Builder.js";
let d=[[[0,"Node",1,"NXObject",0]],[],[]];
SPLM.LineDesigner.FactoryCadGeoEquipmentBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.LineDesigner.FactoryCadGeoEquipmentBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.LineDesigner.FactoryCadGeoEquipmentBuilder.UpdatedControlData = class{
    constructor(sControlName,dControlValue,dMinValue,dMaxValue,dIncrement,vDblLov,vStrLov,bEnforceValues,bIsEditable){
        this.sControlName=sControlName;this.dControlValue=dControlValue;this.dMinValue=dMinValue;this.dMaxValue=dMaxValue;this.dIncrement=dIncrement;this.vDblLov=vDblLov;this.vStrLov=vStrLov;this.bEnforceValues=bEnforceValues;this.bIsEditable=bIsEditable;}
    get Scontrolname(){return this.sControlName}
    set Scontrolname(val){this.sControlName = val}
    get Dcontrolvalue(){return this.dControlValue}
    set Dcontrolvalue(val){this.dControlValue = val}
    get Dminvalue(){return this.dMinValue}
    set Dminvalue(val){this.dMinValue = val}
    get Dmaxvalue(){return this.dMaxValue}
    set Dmaxvalue(val){this.dMaxValue = val}
    get Dincrement(){return this.dIncrement}
    set Dincrement(val){this.dIncrement = val}
    get Vdbllov(){return this.vDblLov}
    set Vdbllov(val){this.vDblLov = val}
    get Vstrlov(){return this.vStrLov}
    set Vstrlov(val){this.vStrLov = val}
    get Benforcevalues(){return this.bEnforceValues}
    set Benforcevalues(val){this.bEnforceValues = val}
    get Biseditable(){return this.bIsEditable}
    set Biseditable(val){this.bIsEditable = val}
};

export default SPLM;